import React from 'react';
import PrematchContext from '../../../../contexts/PrematchContext';
import { classIf } from '../../../../data/utils';
import FavoriteTournamentToggle from '../../../../prematch/favorite-tournaments/FavoriteTournamentToggle';

function TournamentItem(props) {
    const prematchContext = React.useContext(PrematchContext);

    function handleClick() {
        prematchContext.toggleTournament(props.uniqueId);
    }

    const selected = prematchContext.isTournamentSelected(props.uniqueId);
    const icoCategory = props.categoryIcon;
    
    return (
        <div className={"elemento-competizioni-widget singola-competizione bg-bianco pointer nero" + classIf(selected, 'competizione-attiva')} onClick={handleClick}>
            <div className="paese-widget-sx">
                <div className={`img-fluid ico-cat ${icoCategory}`}></div>
                <span>{props.descrizione}</span>
            </div>
            {props.isLive &&
                <span className="live-badge mr-1"></span>
            }
            <FavoriteTournamentToggle className="ml-auto" uniqueId={props.uniqueId} />
        </div>
    );
}

export default TournamentItem;